import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import DetailsCard from '../../subscription/details/components/DetailsCard';
import CustomButton from '../../../components/buttons/CustomButton';
import { IndicateColleagueAPI } from '../../../api/ReferralAPI';
import { maskPhone, onlyDigits } from '../../PublicPatientRegistration/registrationMasks';
import { CATEGORY_OPTIONS } from '../../admin/prospects/prospectOptions';
import styles from '../Referral.module.css';

const EMPTY = { name: '', whatsapp: '', category: '' };

/**
 * Indicação direta: nome + WhatsApp. A equipe da Gabriela faz o contato pessoal.
 * @param {Object} props
 * @param {number} props.dailyLimit
 * @param {Function} props.onDone (message, severity) depois de registrar
 */
function ReferralIndicateCard({ dailyLimit, onDone }) {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  const digits = onlyDigits(form.whatsapp);
  const canSend = !sending && form.name.trim().length >= 2 && digits.length >= 10 && digits.length <= 11;

  const update = (field) => (event) => {
    const value = field === 'whatsapp' ? maskPhone(event.target.value) : event.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSend) return;
    setSending(true);
    IndicateColleagueAPI({ name: form.name.trim(), whatsapp: digits, category: form.category || undefined }, (response) => {
      setSending(false);
      if (!response || response.success === false) {
        onDone(response?.error || 'Não foi possível registrar a indicação. Tente de novo.', 'error');
        return;
      }
      setForm(EMPTY);
      // Mesma mensagem sempre: a tela nunca diz se um número já era conhecido
      onDone('Indicação registrada. A equipe da Gabriela vai falar com essa pessoa em seu nome.', 'success');
    });
  };

  return (
    <DetailsCard title="Indicar um colega" subtitle="A equipe da Gabriela entra em contato e apresenta o sistema em seu nome.">
      <form className={styles.form} onSubmit={handleSubmit} noValidate>
        <TextField
          label="Nome"
          value={form.name}
          onChange={update('name')}
          size="small"
          fullWidth
          inputProps={{ maxLength: 120 }}
        />
        <div className={styles.formRow}>
          <TextField
            label="WhatsApp com DDD"
            value={form.whatsapp}
            onChange={update('whatsapp')}
            size="small"
            fullWidth
            inputMode="tel"
            placeholder="(11) 99999-9999"
          />
          <TextField
            label="Área de atuação"
            value={form.category}
            onChange={update('category')}
            size="small"
            fullWidth
            select
          >
            <MenuItem value="">Não sei</MenuItem>
            {CATEGORY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </TextField>
        </div>
        <div className={styles.formFooter}>
          <p className={styles.formHint}>Até {dailyLimit} indicações por dia. Indique só quem você conhece.</p>
          <CustomButton
            style="primary"
            variant="contained"
            label="Indicar"
            icon={<SendOutlinedIcon fontSize="small" />}
            enabled={canSend}
            loading={sending}
            onClick={handleSubmit}
          />
        </div>
      </form>
    </DetailsCard>
  );
}

export default ReferralIndicateCard;
